/**
 * API代码生成器
 * 支持生成curl、PHP、Python等语言的示例代码
 */

/**
 * 生成curl命令
 */
export function generateCurl(request) {
  const { method, url, headers, body } = request;
  
  let curl = `curl -X ${method.toUpperCase()} "${url}"`;
  
  // 添加请求头
  if (headers) {
    Object.keys(headers).forEach(key => {
      if (key.toLowerCase() !== 'content-length') {
        curl += ` \\\n  -H "${key}: ${headers[key]}"`;
      }
    });
  }
  
  // 添加请求体
  if (body && (method.toUpperCase() === 'POST' || method.toUpperCase() === 'PUT' || method.toUpperCase() === 'PATCH')) {
    const bodyStr = typeof body === 'string' ? body : JSON.stringify(body, null, 2);
    curl += ` \\\n  -d '${bodyStr}'`;
  }
  
  return curl;
}

/**
 * 生成PHP代码
 */
export function generatePHP(request) {
  const { method, url, headers, body } = request;
  
  let php = `<?php\n\n`;
  php += `$url = "${url}";\n`;
  php += `$method = "${method.toUpperCase()}";\n\n`;
  
  // 添加请求头
  if (headers && Object.keys(headers).length > 0) {
    php += `$headers = array(\n`;
    const headerKeys = Object.keys(headers).filter(key => key.toLowerCase() !== 'content-length');
    headerKeys.forEach((key, index) => {
      const comma = index < headerKeys.length - 1 ? ',' : '';
      const value = headers[key].replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      php += `    "${key}" => "${value}"${comma}\n`;
    });
    php += `);\n\n`;
  } else {
    php += `$headers = array();\n\n`;
  }
  
  // 添加请求体
  if (body && (method.toUpperCase() === 'POST' || method.toUpperCase() === 'PUT' || method.toUpperCase() === 'PATCH')) {
    const bodyStr = typeof body === 'string' ? body : JSON.stringify(body, null, 2);
    php += `$data = '${bodyStr.replace(/'/g, "\\'")}';\n\n`;
  }
  
  php += `$ch = curl_init();\n`;
  php += `curl_setopt($ch, CURLOPT_URL, $url);\n`;
  php += `curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);\n`;
  php += `curl_setopt($ch, CURLOPT_CUSTOMREQUEST, $method);\n\n`;
  
  if (headers && Object.keys(headers).length > 0) {
    php += `$headerArray = array();\n`;
    php += `foreach ($headers as $key => $value) {\n`;
    php += `    $headerArray[] = $key . ': ' . $value;\n`;
    php += `}\n`;
    php += `curl_setopt($ch, CURLOPT_HTTPHEADER, $headerArray);\n\n`;
  }
  
  if (body && (method.toUpperCase() === 'POST' || method.toUpperCase() === 'PUT' || method.toUpperCase() === 'PATCH')) {
    php += `curl_setopt($ch, CURLOPT_POSTFIELDS, $data);\n\n`;
  }
  
  php += `$response = curl_exec($ch);\n`;
  php += `$httpCode = curl_getinfo($ch, CURLINFO_HTTP_CODE);\n`;
  php += `curl_close($ch);\n\n`;
  php += `echo "HTTP Code: " . $httpCode . "\\n";\n`;
  php += `echo "Response: " . $response . "\\n";\n`;
  php += `?>\n`;
  
  return php;
}

/**
 * 生成Python代码（使用requests库）
 */
export function generatePython(request) {
  const { method, url, headers, body } = request;
  
  let python = `import requests\n`;
  python += `import json\n\n`;
  python += `url = "${url}"\n`;
  python += `method = "${method.toUpperCase()}"\n\n`;
  
  // 添加请求头
  if (headers && Object.keys(headers).length > 0) {
    python += `headers = {\n`;
    const headerKeys = Object.keys(headers).filter(key => key.toLowerCase() !== 'content-length');
    headerKeys.forEach((key, index) => {
      const comma = index < headerKeys.length - 1 ? ',' : '';
      const value = headers[key].replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      python += `    "${key}": "${value}"${comma}\n`;
    });
    python += `}\n\n`;
  } else {
    python += `headers = {}\n\n`;
  }
  
  // 添加请求体
  if (body && (method.toUpperCase() === 'POST' || method.toUpperCase() === 'PUT' || method.toUpperCase() === 'PATCH')) {
    const bodyStr = typeof body === 'string' ? body : JSON.stringify(body, null, 2);
    python += `data = ${bodyStr}\n\n`;
  }
  
  python += `response = requests.request(method, url, headers=headers`;
  
  if (body && (method.toUpperCase() === 'POST' || method.toUpperCase() === 'PUT' || method.toUpperCase() === 'PATCH')) {
    python += `, json=data`;
  }
  
  python += `)\n\n`;
  python += `print(f"Status Code: {response.status_code}")\n`;
  python += `print(f"Response: {response.text}")\n`;
  python += `\n# 如果需要解析JSON响应\n`;
  python += `# response_json = response.json()\n`;
  python += `# print(json.dumps(response_json, indent=2))\n`;
  
  return python;
}

/**
 * 从Swagger UI的请求对象生成代码
 */
export function generateCodeFromRequest(request, language = 'curl') {
  const generators = {
    curl: generateCurl,
    php: generatePHP,
    python: generatePython,
  };
  
  const generator = generators[language.toLowerCase()];
  if (!generator) {
    throw new Error(`Unsupported language: ${language}`);
  }
  
  return generator(request);
}

